import { Group } from 'types/groups';
import * as yup from 'yup';

export const getInitialValues = (group: Group | null) => ({
  companyName: group?.companyName || '',
  //billingContact: group?.billingContact || '',
  type: group?.type || '',
  sites: (group as any)?.sites || [],
  banner: (group as any)?.banner || '',
});

export const validationSchema = yup.object().shape({
  companyName: yup.string().required('company name is required'),
  //billingContact: yup.string().required('billing contact is required'),
  type: yup.string().required('type is required'),
  sites: yup.array().min(1, 'Please select at least one site'),
});
